import React from "react";
import logo from "../../images/logo.png";
import loader from "../../images/loader.gif";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet/es/Helmet";

class ShoppingCart extends React.Component {
  constructor(props) {
    super(props);

    this.getShopTotal = this.getShopTotal.bind(this);
    this.removeItem = this.removeItem.bind(this);
  }

  getShopTotal(products) {
    let total = 0;
    products.forEach((product) => {
      total += product.qty * product.product.item.price;
    });

    return total.toLocaleString();
  }

  removeItem(product, shopId) {
    let newCart = [];
    this.props.shoppingCart.forEach((shop) => {
      if (shop.shopId === shopId) {
        console.log("found match");
        let newShopProductsOnCart = [];
        shop.products.forEach((prd) => {
          if (prd.product.item.id !== product.product.item.id) {
            console.log("second match here", product, prd);
            newShopProductsOnCart.push(prd);
          }
        });
        if (newShopProductsOnCart.length > 0) {
          shop.products = newShopProductsOnCart;
          newCart.push(shop);
        }
      } else {
        newCart.push(shop);
      }
    });

    this.props.updateShoppingCart(newCart);
  }

  render() {
    return (
      <div className="">
        <Helmet>
          <link rel="icon" href={logo} />
          <title>Shopping Cart | VehShop</title>
        </Helmet>
        <div className="modal is-active animated zoomIn">
          <div className="modal-background"></div>
          <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title">Cart</p>
              <span className="m-2">
                <img className="is-hidden" src={loader} alt="processing..." />
              </span>
              <div>
                <Link
                  to={
                    this.props.shop
                      ? `/shop-at/${this.props.shop.name.replace(
                          /\s+/g,
                          "-"
                        )}/${this.props.shop.id}/`
                      : "/market/"
                  }
                >
                  <button className="delete" aria-label="close"></button>
                </Link>
              </div>
            </header>

            <section className="modal-card-body">
              {this.props.shoppingCart ? (
                <div>
                  {this.props.shoppingCart.map((shop) => (
                    <div key={shop.shopId + "-cart-item"}>
                      <div className="message">
                        <div className="message-body">
                          <div className="d-flex justify-content-between">
                            <div className="is-size-5 has-text-link">
                              {shop.shopName}
                            </div>
                            <div>
                              <span>{shop.currency}</span>{" "}
                              {this.getShopTotal(shop.products)}
                            </div>
                          </div>
                          <div className="m-2">
                            {shop.products.map((product) => (
                              <div
                                key={
                                  product.product.item.id + "-cart-item-product"
                                }
                                className=""
                              >
                                <div className="d-flex justify-content-between">
                                  <span>{product.product.item.name}</span>
                                  <span className="has-text-info">
                                    {product.qty.toLocaleString()}
                                    <span className="ml-2">
                                      <button
                                        type="button"
                                        onClick={() => {
                                          this.removeItem(product, shop.shopId);
                                        }}
                                        title="Remove Item"
                                        className="delete"
                                      ></button>
                                    </span>
                                  </span>
                                </div>
                                <div>
                                  <small className="has-text-primary">
                                    {shop.currency}{" "}
                                    {product.product.item.price.toLocaleString()}
                                    /{product.product.item.unit}
                                  </small>
                                </div>
                                <br />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <hr />
                    </div>
                  ))}
                </div>
              ) : (
                <div>
                  <div className="has-text-centered">Empty Cart</div>
                </div>
              )}
            </section>

            <footer className="modal-card-foot d-flex justify-content-between">
              <button
                onClick={() => {
                  this.props.updateShoppingCart(null);
                }}
                className="button"
              >
                <span className="zmdi zmdi-close-circle mr-1"></span>
                Clear Cart
              </button>
              <button className="button is-success">
                <span className="zmdi zmdi-money mr-1"></span>
                Place All
              </button>
            </footer>
          </div>
        </div>
      </div>
    );
  }
}

export default ShoppingCart;
